<template>
	<div class="date-dropdown-container row">
		<!-- <span class="d-none">{{ authInfo }}</span> -->
		<div class="select-custom date-dropdown-select-wrapper col-4 ">
			<select v-model="selectedDay" class="date-dropdown-select day">
				<option v-for="day in days" :key="day.day">
					{{ day.day }}
				</option>
			</select>
			<i class="fa fa-angle-down primary-color"></i>
		</div>

		<!-- Month -->
		<div class="select-custom date-dropdown-select-wrapper col-4">
			<select v-model="selectedMonth" @change="updateDays()" class="date-dropdown-select month">
				<option v-for="(month, index) in months" :value="index" :key="month.month">
					{{ month.month }}
				</option>
			</select>
			<i class="fa fa-angle-down primary-color"></i>
		</div>

		<!-- Year -->
		<div class="select-custom date-dropdown-select-wrapper col-4 ">
			<select v-model="selectedYear" @change="updateDays()" class="date-dropdown-select year">
				<option v-for="year in years" :key="year.year">
					{{ year.year }}
				</option>
			</select>
			<i class="fa fa-angle-down primary-color"></i>
		</div>

	</div>
</template>

<script>
	import { getAuth } from '@/utils/jwt'

	const dfMonths = {
		0: 'January',
		1: 'February',
		2: 'March',
		3: 'April',
		4: 'May',
		5: 'June',
		6: 'July',
		7: 'August',
		8: 'September',
		9: 'October',
		10: 'November',
		11: 'December'
	}

	export default {
		name: "DateControl",
		props: {
			default: {
				type: String,
				required: false
			},
			min: {
				type: String,
				required: false
			},
			max: {
				type: String,
				required: false
			},
			monthsNames: {
				type: String,
				required: false
			},
			dateVal: {
				type: String,
				required: false
			},
		},

		data () {
			return {
				days: [],
				selectedDay: '1',
				selectedMonth: '0',
				selectedYear: '2020'
			}
		},
		created() {
			// Set the date when the component was created
			//this.setDate()
			this.updateDays();
			if(this.dateVal)
				this.setInitializeDate(this.dateVal);
		},
		watch:{
			// default(newVal){
			// 	//this.setInitializeDate(newVal);
			// 	console.log(newVal);
			// },
			dateVal (newVal, oldVal) { // watch it
				// if(newVal!=oldVal){
				this.setInitializeDate(newVal);
				// }
				// console.log('Prop changed: ', newVal, ' | was: ', oldVal)
			}	
		},
		computed: {
			// Returns if there are default date settings.
			initialDate() {
				return !! (this.default || this.min)
			},

			// The date property, converted to a date.
			specifiedDate() {
				return new Date(this.default)
			},

			// The minimum date the will allow user to select.
			minDate() {
				if (this.min)
					return new Date(this.min)
				return new Date(1900,1,1);
			},

			// The maximum date the will allow user to select.
			maxDate() {
				if (this.max)
					return new Date(this.max)

				return new Date(2200,1,1);
			},

			// Returns a formatted date e.g. 01.02.2018.
			calculatedDate() {
				const day = parseInt(this.selectedDay) >= 10 ? this.selectedDay : `0${this.selectedDay}`
				const month = parseInt(this.selectedMonth) + 1 >= 10 ? parseInt(this.selectedMonth) + 1 : `0${parseInt(this.selectedMonth) + 1}`
				// const month = parseInt(this.selectedMonth) + 1 >= 10 ? parseInt(this.selectedMonth) : `0${parseInt(this.selectedMonth)}`

				// return `${month}/${day}/${this.selectedYear}`
				// return `${day}-${month}-${this.selectedYear}`
				return `${this.selectedYear}-${month}-${day}`
			},

			// The alternative names of months
			dividedNamesOfMonths() {
				if (this.monthsNames)
					return this.monthsNames.split(',')
				return []
			},

			// Computes a list of month.
			months() {
				let months = []

				for (let i = 0; i < 12; i++) {
					if (this.dividedNamesOfMonths)
						months.push(this.dividedNamesOfMonths[i])
					else
						months.push(dfMonths[i])
				}
				var monSelected=this.selectedMonth;
				if(this.selectedMonth==null||this.selectedMonth<1){
					monSelected=0;
				}
				return months.map((month, index) => {
					return { month, selected: index === monSelected }
				})
			},

			// Computes a list of years.
			years() {
				// Set the first year of the array.
				let firstYear
				if (this.min) {
					firstYear = this.minDate.getFullYear()
				}else {
					firstYear = (new Date).getFullYear()
				}

				// Create a range of years to loop through which is either the maximum
				// date minus the first year, or simply 100.
				let through = this.max ? (this.maxDate.getFullYear() + 1) - firstYear : 101
				let years = []

				for (let i = firstYear, len = firstYear + through; i < len; i++)
					years.push(i)

				var yearSelected=this.selectedYear;
				if(this.selectedYear==null||this.selectedYear<1){
					yearSelected=1;
				}
				return years.map((year) => {
					return { year, selected: year === yearSelected }
				})
			},
			authInfo() {
				return getAuth();
			}
		},
		updated() {
			// Send the data on change
			this.sendDate()
		},

		methods: {

			getDays() {
				let days = []
				let daysNumberOfMonth = new Date(this.selectedYear, this.selectedMonth + 1, 0).getDate()

				for (let i = 1; i < daysNumberOfMonth + 1; i++)
					days.push(i)
				if(this.selectedDay>=daysNumberOfMonth){
					this.selectedDay=1;
				}
				return days.map((day) => {
					return { day, selected: days === this.selectedDay }
				})
			},

			updateDays() {
				this.days = this.getDays()
			},

			// Send data to upper component.
			sendDate() {
				const date = this.format ? this.format(this.calculatedDate) : this.calculatedDate
				this.$emit('input', date)
			},
			setInitializeDate(newVal){
				// let date
				// Date data has format: YYYY-MM-DD : string
				if(newVal){
					const dateArr = newVal.split('-')
					// date = new Date(newVal)
					const newYear = dateArr[0]
					const newMonth = dateArr[1]
					const newDay = dateArr[2]
					let isUpdate=false;
					if (this.selectedDay != newDay) {
						this.selectedDay = newDay
					}
					if (this.selectedMonth != newMonth) {
						this.selectedMonth = newMonth - 1
					}
					if (this.selectedYear != newYear) {
						this.selectedYear = newYear
					}
					isUpdate=true;
					// if(this.selectedDay != date.getDate()){
					// 	this.selectedDay = date.getDate();
					// 	isUpdate=true;
					// }
					// if(this.selectedMonth != date.getMonth()){
					// 	this.selectedMonth = date.getMonth();
					// 	isUpdate=true;
					// }
					// if(this.selectedYear != date.getFullYear()){
					// 	this.selectedYear = date.getFullYear();
					// 	isUpdate=true;
					// }
					// if(isUpdate==true){
					// 	this.sendDate();
					// }
				}
			},
			// Set the initial date.
			setDate(newVal) {
				// If a value property has been passed to the component, that will be
				// used instead of the current day.
				let date
				if(newVal){
					date = new Date(newVal)
				}
				else if (this.min && this.max && !this.default) {
					date = new Date(this.min)
				} else if (this.default) {
					date = new Date(this.default)
				} else {
					date = new Date()
				}
				this.updateDays()

				if (this.initialDate)
					this.selectedDay = date.getDate() + 1
				else
					this.selectedDay = date.getDate()

				this.selectedDay = date.getDate()
				this.selectedMonth = date.getMonth()
				this.selectedYear = date.getFullYear()

				this.sendDate()				
				this.$emit('input', this.dateVal)
			}
		}
	}
</script>

<style scoped>
	.date-dropdown-container {
		display: flex;
	}
	.date-dropdown-select {
		display: inline-block;
		border: 1px solid #f3f6fb;
		border-radius: 3px;
		padding: 8px;
		margin-right: 10px;
		width: 100%;
		color: #879AA9;
	}
	.date-dropdown-container .select-custom i {
	    position: absolute;
	    top: 0px;
	    right: 10px;
	    color: #879AA9;
	    line-height: 30px;
	    padding-right: 15px;
	    pointer-events: none;
	}
</style>